import type { ContactRole, RepKind, RoleKey } from '@/api/base-types';

/**
 * Подписи интерфейса M2. «Руководитель» везде полностью — «руководитель
 * команды», чтобы не путать с руководителем студии (БЛ 11.7).
 */
export const ROLE_LABEL: Record<RoleKey, string> = {
  head: 'Руководитель команды',
  contact: 'Контакт студии',
  participant: 'Участник',
  rep: 'Представитель',
};

/**
 * «Контакт студии» на экранах не пишется — вместо него конкретная роль
 * из связи (доработка M2-1 п. 3, БЛ 1.4): так руководителя студии
 * не перепутать с руководителем команды. Подраздел списка «Контакты
 * студий» остаётся как есть.
 */
export const STUDIO_ROLE_LABEL: Record<ContactRole, string> = {
  head: 'Руководитель студии',
  choreographer: 'Хореограф студии',
  admin: 'Администратор студии',
};

/** Подписи ролей клиента: роль контакта раскрыта в конкретные, без повторов (roleLabels в макете) */
export function roleLabels(roles: RoleKey[], studioRoles: ContactRole[]): string[] {
  return roles.flatMap((r) =>
    r === 'contact' && studioRoles.length ? studioRoles.map((s) => STUDIO_ROLE_LABEL[s]) : [ROLE_LABEL[r]],
  );
}

/** «Руководитель команды, хореограф студии» — первая с заглавной, как в макете */
export function rolesLine(roles: RoleKey[], studioRoles: ContactRole[]): string {
  return roleLabels(roles, studioRoles)
    .map((l, i) => (i ? l.toLowerCase() : l))
    .join(', ');
}

export const CONTACT_ROLE: Record<ContactRole, string> = {
  head: 'руководитель',
  choreographer: 'хореограф',
  admin: 'администратор',
};

export const CONTACT_ROLE_ITEMS: { value: ContactRole; label: string }[] = [
  { value: 'head', label: 'Руководитель' },
  { value: 'choreographer', label: 'Хореограф' },
  { value: 'admin', label: 'Администратор' },
];

export const REP_KIND: Record<RepKind, string> = {
  mother: 'мать',
  father: 'отец',
  other: 'иной представитель',
};

export const REP_KIND_ITEMS: { value: RepKind; label: string }[] = [
  { value: 'mother', label: 'Мать' },
  { value: 'father', label: 'Отец' },
  { value: 'other', label: 'Иной представитель' },
];

/** ISO → ДД.ММ.ГГГГ */
export const ruDate = (iso: string | null | undefined) => (iso ? iso.slice(0, 10).split('-').reverse().join('.') : '');

/** ДД.ММ из ISO — «с 01.09» в строках состава */
export const ruDay = (iso: string) => ruDate(iso);
